import React from 'react';
import { getTracking } from 'ts-tracking-number';
import { registrationText } from './constants';
import { LinkWithNativeEvents } from '../../components/_common/link/link';

export const VehicleRegistrationTrackingDescription = (trackingNumber: string) => {
  const trackingInfo = getTracking(trackingNumber);

  const courierCode = trackingInfo?.courier.code;
  const trackingUrl = trackingInfo?.trackingUrl?.replace('%s', trackingInfo.trackingNumber) ?? '';

  if (!trackingInfo) {
    return registrationText.COMPLETED.fedExNoTransfer.replace('{trackingNumber}', trackingNumber);
  }

  return (
    <p>
      Your registration is completed! Your plates and tags are being sent to you via{' '}
      {trackingInfo.courier.code.toUpperCase()} and the tracking number is{' '}
      <LinkWithNativeEvents
        href={trackingUrl}
        target="_blank"
        rel="noopener noreferrer"
        nativeEvent={{
          event: 'link',
          payload: { url: trackingUrl },
        }}
      >
        {trackingInfo.trackingNumber}
      </LinkWithNativeEvents>
      . Since this is a highly important package, {courierCode?.toUpperCase()} may require a signature at delivery in
      order to release the package.
    </p>
  );
};
